import { useState, useEffect } from 'react'
import PDF from "./PDF.tsx"
import PubMed from './Pubmed.tsx'

function App() {
    const [highlightText, setHighlightText] = useState('');
    const [url, setUrl] = useState(null);
    const [isPDF, setIsPDF] = useState(false)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const url = urlParams.get('url');
        const highlightText = urlParams.get('highlight');
        if (url) {
            setIsPDF(url.toLowerCase().includes('pdf'))
            setUrl(url);

        }
        if (highlightText) {
            setHighlightText(highlightText)
        }
    }, [highlightText, url]);

    return (
        <div>
            {isPDF ? <PDF url={url} highlightText={highlightText} /> : <PubMed url={url} highlightText={highlightText} />}
        </div>
    );
}

export default App;
